import Block from '../../common.blocks/block'
import $ from 'jquery'

export default class Nav extends Block {
	static title = 'nav'

	constructor($el) {
		super($el)

		// Cached selectors
		this.subInners = $('.nav__sub-inner')
		this.navItems = this.$el.findElement('sub-item--dynamic')
		this.icons = this.$el.findElement('mobile-icon')
		this.backButtons = this.$el.findElement('mobile-back')
		this.$mobileDropdown = this.$el.findElement('mobile-dropdown')

		this.bindEvents()
	}

	bindEvents() {
		// Shopping cart
		this.$el.find('.nav__item[data-shoppingcart]').on('click', (e) => {
			e.preventDefault()
			$(document).trigger('nav:open-shoppingcart')
		})

		// Close search on hover
		this.$el.findElement('item').on('mouseover', () => {
			$(document).trigger('search:close')
		})

		// Desktop hover menus
		this.navItems.on('mouseover', (e) => this.toggleSub($(e.currentTarget)))

		this.$el.on('mouseleave', () => {
			this.subInners.removeClass('nav__sub-inner--active')
		})

		// Mobile toggle
		this.$el.findElement('mobile-toggle').on('click', () => {
			this.$mobileDropdown.toggleClass('nav__mobile-dropdown--active')
			this.closeMobileSub()
		})

		this.$el.findElement('mobile-close').on('click', () => {
			this.$mobileDropdown.removeClass('nav__mobile-dropdown--active')
			this.closeMobileSub()
		})

		// Mobile icons & back buttons
		this.icons.add(this.backButtons).on('click', (e) => {
			this.toggleMobileSub($(e.currentTarget))
		})

		// Search
		this.$el.findElement('open-search').on('click', () => {
			$(document).trigger('search:open')
		})
	}

	toggleSub(el) {
		const id = el.data('sub')
		this.subInners.removeClass('nav__sub-inner--active')
		$(`.nav__sub-inner[data-sub="${id}"]`).toggleClass('nav__sub-inner--active')
	}

	toggleMobileSub(el) {
		const id = el.data('sub')
		this.$el
			.find(`.nav__mobile-container--sub[data-sub="${id}"]`)
			.toggleClass('nav__mobile-container--hidden')
	}

	closeMobileSub() {
		this.$el
			.findElement('mobile-container--sub')
			.addClass('nav__mobile-container--hidden')
	}
}
